var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingSkipTrashingFactor } from "../../balancingSelectors/selectBalancingConstants";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilSkipProcess } from "../../utils/utilSkipProcess";
import { utilTime } from "../../utils/utilTime";
import { ButtonSecondaryMedium } from "../generic/common/ButtonSecondaryMedium";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionContractRequestSkip } from "./actionContractInfo";
import { MarketTimerCountdown } from "./MarketTimerCountdown";
var DetailViewMarketTrashWaitingDOM = /** @class */ (function (_super) {
    __extends(DetailViewMarketTrashWaitingDOM, _super);
    function DetailViewMarketTrashWaitingDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSkipGold = function () {
            var _a = _this.props, skipContract = _a.skipContract, item = _a.item, remainingTime = _a.remainingTime;
            var timeLeft = utilTime.secondsLeftTill(remainingTime);
            var goldRequired = utilSkipProcess.calculateCostToSkipProcess(timeLeft, selectBalancingSkipTrashingFactor());
            return (React.createElement(ButtonSecondaryMedium, { onClick: function () { return skipContract(item.contractId); } },
                React.createElement("div", { className: "flex flex--stacked flex--guts" },
                    React.createElement("div", null,
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.skip })),
                    React.createElement("div", { className: "flex flex--guts" },
                        React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: IdIcon.GoldIcn }),
                        React.createElement("div", { className: IdStyles.TextBoldSecondary }, goldRequired)))));
        };
        return _this;
    }
    DetailViewMarketTrashWaitingDOM.prototype.render = function () {
        var remainingTime = this.props.remainingTime;
        return (React.createElement("div", { className: IdStyles.DetailViewWrapper + " flex flex--guts" },
            React.createElement("div", { className: "" + IdStyles.DetailView },
                React.createElement("div", { className: "market-menu-trash" },
                    React.createElement("div", { className: "market-menu-trash__heading " + IdStyles.TextButtonHeading },
                        React.createElement(TextLoca, { id: IdLoca.contractsNew_title })),
                    React.createElement(MarketTimerCountdown, { remainingTime: remainingTime }),
                    React.createElement("div", { className: "market-menu-trash__info " + IdStyles.MarketMenuRequirementsBackground + " " + IdStyles.TextNormal },
                        React.createElement(TextLoca, { id: IdLoca.contractsNew_desc })),
                    this.getSkipGold()))));
    };
    return DetailViewMarketTrashWaitingDOM;
}(React.Component));
var mapDispatch = function (dispatch) { return ({
    skipContract: function (contractId) { return dispatch(actionContractRequestSkip(contractId)); },
}); };
export var DetailViewMarketTrashWaiting = connect(undefined, mapDispatch)(DetailViewMarketTrashWaitingDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/DetailViewMarketTrashWaiting.tsx
// module id = 2715
// module chunks = 3